<script lang="ts">
import { AttachmentType } from '@smartsupp/smartsupp-message'
import { getContext } from 'svelte'
import DownloadIcon from 'virtual:icons/lucide/download'

import { testIds } from '@/constants'
import { PreviewedMediaType } from '@/modules/app'
import { previewedMedia } from '@/modules/app/mediaPreview'
import { getDownloadUrl, prettyFileSize, prettyFileType } from '@/modules/fileUpload/utils'
import { contentMessageAttachmentKey, type WritableMessageAttachmentContext } from '@/modules/messages'
import { isFileVideo } from '@/utils/file'

import MessageContent from './MessageContent.svelte'

let context = $derived(getContext<WritableMessageAttachmentContext>(contentMessageAttachmentKey))
let attachment = $derived($context.attachment)

const fileSize = (fileSize?: number) => {
	if (typeof fileSize !== 'number') return ''
	const { size, unit } = prettyFileSize(fileSize)
	return `${size} ${unit}`
}

const showVideoPreview = (e: Event) => {
	if (attachment.type === AttachmentType.File && isFileVideo(attachment.fileType || '')) {
		e.preventDefault()
		previewedMedia.set({ attachment, type: PreviewedMediaType.Video })
	}
}
</script>

{#if attachment && attachment.type === AttachmentType.File}
	<a
		class="block"
		href={getDownloadUrl(attachment.url, attachment.fileName)}
		download={attachment.fileName}
		target="_blank"
		rel="noreferrer"
		onclick={showVideoPreview}
		data-testid={testIds.messageFile}
	>
		<MessageContent>
			<div class="flex w-full items-center no-underline">
				<div class="flex-grow flex flex-col">
					<div>{attachment.fileName}</div>
					<div>{fileSize(attachment.size)}</div>
				</div>
				<div class="flex-shrink px-3 font-bold text-sm whitespace-nowrap select-none">
					{prettyFileType(attachment.fileName)}
				</div>
				<div class="flex-shrink">
					<div class="inline-block p-2 bg-slate-100 text-neutral-500 rounded-full">
						<DownloadIcon width="1em" height="1em" style={'transform: scale(1.2);'} />
					</div>
				</div>
			</div>
		</MessageContent>
	</a>
{/if}
